import { Copy, ExternalLink, MessageCircle, Share2 } from "lucide-react";
import { toast } from "sonner";
import {
    DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { copyText, nativeShare, whatsappShareUrl } from "./shareUtils";

/** Share dropdown: WhatsApp · native share · copy link · open (optional). */
export function ShareMenu({ label, url, message, openHref, testId, primary = false, disabled = false, onShared,
    title = "Anand Tutorials — International Time Converter", className = "" }) {
    const copyLink = async () => {
        (await copyText(url)) ? toast.success("Link copied") : toast.error("Couldn't copy — please copy the link manually");
        onShared?.();
    };
    const share = async () => {
        const res = await nativeShare({ title, text: message });
        if (res === "shared") { toast.success("Shared"); onShared?.(); }
        else if (res === "unsupported" || res === "error") {
            (await copyText(message)) ? toast.success("Device sharing isn't available here — message copied instead") : toast.error("Sharing failed");
        }
    };
    const item = "cursor-pointer gap-2 py-2.5";
    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild disabled={disabled}>
                <button type="button" data-testid={testId} disabled={disabled}
                    className={`h-11 inline-flex items-center justify-center gap-2 px-4 rounded-lg text-sm font-bold transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${primary ? "bg-amber-500 text-[#0F172A] hover:bg-amber-400" : "bg-white border border-slate-200 text-[#0F172A] hover:border-[#1E3A8A]"} ${className}`}>
                    <Share2 className="w-4 h-4" /> {label}
                </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="start" className="w-60">
                <DropdownMenuItem asChild className={item}>
                    <a href={whatsappShareUrl(message)} target="_blank" rel="noopener noreferrer" data-testid={`${testId}-whatsapp`} onClick={() => onShared?.()}>
                        <MessageCircle className="w-4 h-4 text-[#25D366]" /> Share via WhatsApp
                    </a>
                </DropdownMenuItem>
                <DropdownMenuItem className={item} onSelect={share} data-testid={`${testId}-native`}>
                    <Share2 className="w-4 h-4" /> Share via device…
                </DropdownMenuItem>
                <DropdownMenuItem className={item} onSelect={copyLink} data-testid={`${testId}-copy`}>
                    <Copy className="w-4 h-4" /> Copy link
                </DropdownMenuItem>
                {openHref && (
                    <DropdownMenuItem asChild className={item}>
                        <a href={openHref} target="_blank" rel="noopener noreferrer" data-testid={`${testId}-open`}>
                            <ExternalLink className="w-4 h-4" /> Open public converter
                        </a>
                    </DropdownMenuItem>
                )}
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
